class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    // Escape header transforms so position:fixed tracks the viewport (Dual H1-safe toast)
    if (this.notification && this.notification.parentElement !== document.body) {
      this.jpToastHome = this.notification.parentElement;
      document.body.appendChild(this.notification);
    }
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
    if (this.jpToastHome && this.notification && this.notification.parentElement === document.body) {
      this.jpToastHome.appendChild(this.notification);
      this.jpToastHome = null;
    }
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.justAddedKeys = this.resolveJustAddedKeys(parsedState);

    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section.id);
      if (!el || !parsedState.sections || !parsedState.sections[section.id]) return;

      if (section.id === 'cart-notification-product') {
        el.innerHTML = this.getJustAddedProductsHTML(
          parsedState.sections[section.id],
          this.justAddedKeys
        );
        this.shortenJustAddedTitles(el);
        return;
      }

      el.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  resolveJustAddedKeys(parsedState) {
    if (Array.isArray(parsedState.justAddedKeys) && parsedState.justAddedKeys.length) {
      return parsedState.justAddedKeys.filter(Boolean);
    }
    if (Array.isArray(parsedState.items) && parsedState.items.length) {
      const keys = parsedState.items.map((item) => item && item.key).filter(Boolean);
      if (keys.length) return keys;
    }
    return parsedState.key ? [parsedState.key] : [];
  }

  /**
   * Dawn's default selector only injects one `#cart-notification-product-${key}`.
   * Multi-add (Dual + accessories) must list every just-added line.
   */

  shortenJustAddedTitles(root) {
    if (!root) return;
    const map = [
      { re: /BOOSTER\s*2\s*Security\s*Lock/i, to: 'Security lock' },
    ];
    root.querySelectorAll('.cart-notification-product__name').forEach((el) => {
      const raw = (el.textContent || '').trim();
      map.forEach(({ re, to }) => {
        if (re.test(raw)) el.textContent = to;
      });
    });
  }

  getJustAddedProductsHTML(sectionHtml, keys) {
    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const wanted = Array.isArray(keys) ? keys.filter(Boolean) : [];

    const nodes = [];
    if (wanted.length) {
      wanted.forEach((key) => {
        const node = doc.getElementById(`cart-notification-product-${key}`);
        if (node) nodes.push(node);
      });
    }
    if (!nodes.length && this.cartItemKey) {
      const node = doc.getElementById(`cart-notification-product-${this.cartItemKey}`);
      if (node) nodes.push(node);
    }
    if (!nodes.length) {
      nodes.push(...Array.from(doc.querySelectorAll('.cart-item')));
    }
    if (!nodes.length) return '';

    // Keep the cart-item card wrapper (charcoal row + white thumb) for 1+ lines.
    return nodes.map((node) => node.outerHTML).join('');
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
